import React from 'react';
import ChevronRightSmall from '@/assets/icons/chevron-right-small.svg';

interface CrowdIndicatorProps {
  level?: number; // 0-4, representing how many dots are filled
  maxLevel?: number; // Total number of dots
  variant?: 'default' | 'homepage-mobile';
  showChevron?: boolean;
  crowdLabel?: string;
  isOpen?: boolean; // If false, all pills will be empty (closed hours)
}

export const CrowdIndicator = ({
  level = 2,
  maxLevel = 4,
  variant = 'default',
  showChevron = false,
  crowdLabel = 'CROWD',
  isOpen = true,
}: CrowdIndicatorProps) => {
  // When location is closed, show all pills as empty
  const displayLevel = isOpen ? level : 0;

  if (variant === 'homepage-mobile') {
    return (
      <div className="inline-flex items-center justify-start gap-1 px-2 py-1 bg-[rgba(71,71,71,0.50)] rounded-[16px] backdrop-blur-[28px]">
        {/* Pills */}
        <div className="flex items-start justify-start gap-0.5 h-2">
          {Array.from({ length: maxLevel }).map((_, index) => (
            <div
              key={index}
              className="w-1.5 self-stretch bg-brand-white rounded-full"
              style={{ opacity: index < displayLevel ? 1 : 0.5 }}
            />
          ))}
        </div>
        {/* Label */}
        <span className="text-brand-white text-bodyxs font-bold break-words">
          {crowdLabel.toUpperCase()}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      {/* Pills */}
      <div className="flex items-start gap-0.5 h-2">
        {Array.from({ length: maxLevel }).map((_, index) => (
          <div
            key={index}
            className="w-1.5 self-stretch rounded-full bg-brand-grey-4"
            style={{ opacity: index < displayLevel ? 1 : 0.5 }}
          />
        ))}
      </div>
      {/* Label */}
      <span className="text-brand-grey-4 text-bodyxs font-bold">
        {crowdLabel.toUpperCase()}
      </span>
      {showChevron && (
        <ChevronRightSmall
          width={10}
          height={10}
          className="fill-current text-brand-grey-4"
        />
      )}
    </div>
  );
};
